export default "__VITE_ASSET__BbyUgfP___"